"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useAppConfig } from "@/context/AppConfigProvider";
import { ROUTES } from "@/constants";

export default function MaintenanceGate() {
    const pathname = usePathname();
    const router = useRouter();
    const { appConfig, loading: configLoading } = useAppConfig();

    useEffect(() => {
        if (configLoading || !appConfig) return;
        const check = async () => {
            try {
                const adminApiUrl = appConfig?.adminApiUrl;
                const res = await fetch(`${adminApiUrl}`);

                const isBlocked = res.status === 200;

                if (isBlocked && pathname !== ROUTES.MAINTENANCE) {
                    router.replace(ROUTES.MAINTENANCE);
                }

                // Optional: if maintenance is OFF and user is stuck on page
                if (!isBlocked && pathname === ROUTES.MAINTENANCE) {
                    router.replace(ROUTES.HOME);
                }
            } catch {
                // in case of error ignore maintenance mode and let user access the app
                console.error("Error checking maintenance mode, allowing access to the app.");
            }
        };

        check();
    }, [pathname, router, appConfig, configLoading]);

    return null;
}